import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';

const PainelTaxa = ({ taxa, tipoTaxa, onTaxaChange, onTipoTaxaChange }) => (
  <Card className="mb-2">
    <Card.Header className="py-1">
      <strong>Taxa</strong>
    </Card.Header>
    <Card.Body>
      <Row className="align-items-center">
        <Col md={2}>
          <Form.Group>
            <Form.Label className="small mb-1">Taxa (%)</Form.Label>
            <Form.Control
              type="number"
              step="0.0001"
              min={0}
              value={taxa}
              onChange={(e) => onTaxaChange(parseFloat(e.target.value) || 0)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label className="small mb-1 d-block">Tipo</Form.Label>
            <Form.Check
              inline
              type="radio"
              label="Juros (F)"
              id="tipo-taxa-f"
              value="F"
              checked={tipoTaxa === 'F'}
              onChange={() => onTipoTaxaChange('F')}
            />
            <Form.Check
              inline
              type="radio"
              label="Desconto (D)"
              id="tipo-taxa-d"
              value="D"
              checked={tipoTaxa === 'D'}
              onChange={() => onTipoTaxaChange('D')}
            />
          </Form.Group>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default PainelTaxa;
